class NSSOverlay extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    /** @type {{ element: string, zIndex: string }[]} */
    this.registered = [];
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Overlay] Connected.");

    this.addEventListener("registerOverlay", this.registerOverlay, false);
    this.addEventListener("unregisterOverlay", this.unregisterOverlay, false);
    this.addEventListener("click", this.closeAll, false);
  }

  closeAll(e) {
    const tags = [...new Set(this.registered.map((r) => r.element))];
    tags.forEach((tag) => {
      const elements = document.querySelectorAll(tag);
      elements.forEach((element) => {
        if (this.debug) console.log(`[NSS][Overlay] Asking to close:`, tag);
        const event = new CustomEvent("overlayClosed");
        element.dispatchEvent(event);
      });
    });
    this.registered = [];
    this.updateOverlay();
  }

  registerOverlay(e) {
    const z = String(e.detail.zIndex ?? ``).trim() || `2`;
    const entry = { element: e.detail.element, zIndex: z };
    const existing = this.registered.findIndex((r) => r.element === entry.element);
    if (existing >= 0) {
      this.registered[existing].zIndex = z;
      if (this.debug) console.log(`[NSS][Overlay] Refreshed z-index:`, entry);
    } else {
      this.registered.push(entry);
      if (this.debug) console.log(`[NSS][Overlay] Registered:`, entry);
    }
    this.updateOverlay();
  }

  unregisterOverlay(e) {
    const el = e.detail.element;
    this.registered = this.registered.filter((r) => r.element !== el);
    if (this.debug) console.log(`[NSS][Overlay] Unregistered:`, el);
    this.updateOverlay();
  }

  updateOverlay() {
    if (this.debug) console.log(`[NSS][Overlay] Updating overlay, this.registered:`, this.registered);
    const docEl = document.documentElement;
    if (this.registered.length > 0) {
      const top = this.registered[this.registered.length - 1];
      this.style.zIndex = top.zIndex;
      this.style.opacity = 1;
      this.style.pointerEvents = `all`;
      const scrollbarWidth = window.innerWidth - docEl.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.classList.add(`nss-no-scroll`);
        docEl.style.setProperty(`--nss-gutter-adjust`, `${scrollbarWidth}px`);
      } else {
        document.body.classList.add(`nss-no-scroll-no-bar`);
      }
    } else {
      this.style.opacity = 0;
      this.style.pointerEvents = `none`;
      document.body.classList.remove(`nss-no-scroll`);
      document.body.classList.remove(`nss-no-scroll-no-bar`);
      docEl.style.setProperty(`--nss-gutter-adjust`, `0px`);
    }
  }
}

let elementName = `nss-overlay`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSOverlay);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}
